module.exports = __webpack_public_path__ + "img/money-out.svg";